import React from 'react';
import { gettext, dangerousGettext } from '@eventbrite/i18n';
import { ICON_SVG } from './PricingPageIcons';
import { Typography, Button } from '@eventbrite/marmalade';
import { getHost } from './utils';

import './SubscriptionTools.scss';

const SUBSCRIPTION_TOOLS = [
    {
        icon: ICON_SVG.ticket,
        headerText: gettext('Easy ticketing'),
        listItems: [
            gettext('Custom event pages'),
            gettext('Multiple ticket types'),
            gettext('Custom registration forms'),
            gettext('AI-powered content tools'),
            gettext('Sell add-ons'),
        ],
    },
    {
        icon: ICON_SVG.megaphone,
        headerText: gettext('Marketing tools'),
        listItems: [
            gettext('Email marketing'),
            gettext('Facebook and Instragram ads'),
            gettext('Eventbrite Ads'),
            gettext('Promo codes'),
            gettext('Organizer profile'),
        ],
    },
    {
        icon: ICON_SVG.card_in_hand,
        headerText: gettext('Secure payments'),
        listItems: [
            gettext('Built-in payment processing'),
            gettext('Pre-event payouts'),
            gettext('Embedded checkout on your own website'),
            gettext('Custom refund policy'),
        ],
    },
    {
        icon: ICON_SVG.trending,
        headerText: gettext('Data insights'),
        listItems: [
            gettext('Sales dashboards'),
            gettext('Traffic and conversion reporting'),
            gettext('Smart audiences'),
            gettext('Ad budget optimization'),
        ],
    },
    {
        icon: ICON_SVG.clipboard,
        headerText: gettext('Event management'),
        listItems: [
            gettext('On-site check in with Organizer app'),
            gettext('Waitlists'),
            gettext('Team permissions'),
            gettext('3rd party integrations'),
            gettext('Courses & video tutorials'),
        ],
    },
];

export const SubscriptionTool = ({ icon, headerText, listItems }) => {
    return (
        <div className="pricing-and-packaging-subscription-tool">
            <div className="tool-icon">{icon}</div>
            <div className="tool-info">
                <div className="tool-name">{headerText}</div>
                <ul className="tool-list">
                    {listItems.map((text, i) => (
                        <Typography color="#1E0A3C" variant="body-md" key={i}>
                            {`${text}`}
                        </Typography>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export const SubscriptionTools = () => {
    const locale = Intl.NumberFormat().resolvedOptions().locale;
    return (
        <div className="subsription-tools-included-plans">
            <div className="subscription-tools-block">
                <div className="pricing-and-packaging-tools">
                    {SUBSCRIPTION_TOOLS.map((toolProps, i) => (
                        <SubscriptionTool key={i} {...toolProps} />
                    ))}
                </div>
                <div className="subscription-tools-block-button">
                    <Button
                        onClick={() => {
                            window.location.href =
                                '/organizer/compare-packages/';
                        }}
                        variant="secondary"
                    >
                        <Typography
                            as="span"
                            color="neutral-900"
                            variant="body-md-bold"
                        >
                            {gettext('View all features and compare plans')}
                        </Typography>
                    </Button>
                </div>
                <div className="subscription-disclaimer-div">
                    <p
                        className="subscription-disclaimer-text"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: dangerousGettext(
                                '*For all plans, ad spend and <a href="%(ticketingFeesUrl)s" target="__blank">Ticketing Fees</a> may apply. Ticketing Fees are paid by ticket buyers unless you choose to cover them.',
                                {
                                    ticketingFeesUrl: `https://${getHost()}/help/${locale.toLowerCase()}/articles/755615`,
                                },
                            ),
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default SubscriptionTools;
